import { FC } from 'react'
import { _ONBOARDED } from '@app/lib/cookies/names'
import { useInteractiveContext } from '@app/components/providers/interactive'
import { PureWebsiteListMock } from './list/pure-website-list-mock'

type DashboardWebsiteListProps = {
  sortModalVisible?: boolean
  queryModalVisible?: boolean
  translation?: string
}

const noop = async () => {}

// DO not memo content
export const DashboardWebsiteListMock: FC<
  DashboardWebsiteListProps & { websitesMock: any; loading?: boolean }
> = ({
  sortModalVisible,
  queryModalVisible,
  translation,
  websitesMock,
  loading,
}) => {
  const { setModal } = useInteractiveContext()

  return (
    <PureWebsiteListMock
      translation={translation}
      sortModalVisible={sortModalVisible}
      queryModalVisible={queryModalVisible}
      data={websitesMock as any}
      error={null}
      crawlWebsite={noop}
      activeCrawls={undefined}
      refetch={noop}
      setModal={setModal}
      onLoadMoreWebsites={noop}
      mutatationLoading={false}
      loading={!!loading}
      removePress={noop}
      onlyLive
    />
  )
}
